import { render } from "./CatalogHero.vue?vue&type=template&id=b75538d0&scoped=true"
import script from "./CatalogHero.vue?vue&type=script&lang=js"
export * from "./CatalogHero.vue?vue&type=script&lang=js"

import "./CatalogHero.vue?vue&type=style&index=0&id=b75538d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75538d0"]])

export default __exports__